import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import your existing translation files
import enTranslations from './locales/en.json';
import heTranslations from './locales/he.json';

const resources = {
  en: {
    translation: enTranslations
  },
  he: {
    translation: heTranslations
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // default language
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    // Enable pluralization
    pluralSeparator: '_',
    
    // Enable context
    contextSeparator: '_',
    
    // Enable nesting
    keySeparator: '.',
    
    // Enable namespaces
    nsSeparator: ':',
    
    // React specific options
    react: {
      useSuspense: false, // Disable Suspense for better SSR support
    }
  });

export default i18n; 